import axios from 'axios';
import qs from "qs";
import { Message } from 'element-ui';

const env = ()=>{
	return window.env;
}

const Axios = axios.create({
	baseURL: env() == 'debug' ? '' : '', 
	timeout: 300000,
	responseType: "json",
	withCredentials: true, // 是否允许带cookie这些
	headers: {
		"content-type": "application/json;charset=utf-8"
	}
});

Axios.interceptors.request.use(
	config => {
		// Message('数据加载中...');
		config.method === "post" ? '' : config.headers['content-type'] = 'application/json;charset=utf-8';
		config.data= config.method != "get" ? config.data : qs.stringify(config.data);
		return config;
	},
	error => {
		Message(error.response.data.error.message);
		return Promise.reject(error);
	}
)

Axios.interceptors.response.use(
	res =>{
		// if(res.data && !res.data.body){
		// 	return res.data;
		// }
		Message.closeAll();
		if(res.data !=null){
			return res.data.body;
		}else{
			return res.data;
		}
		
	},
	error =>{
		// Message(error.response.data.error.message);
		if(error.response.data.error.code == '10012206') {
			// window.location.href = '/'
		} else {
			Message(error.response.data.error.message);
		}
		return Promise.reject(error);
	}
)


// 实例重新封装成一个plugin ,方便 Vue.use(xxxx)
export default {
		install: function(Vue) {
				Object.defineProperty(Vue.prototype, "$http", { value: Axios });
		}
};